export const RULE_PARAMS = {
    GNSS_STATUS: "gnss_status",
    IDLING_TIME: "idlingTime",
    ACCELERATE: "accelerate",
    PANIC_DI1_LATCH: "panic_di1_latch",
    CELL_CONNECTIVITY: "cell_connectivity",
    SPEED: "speed",
    PARKING_TIME: "parkingTime",
    IGNITION: "ignition",
    iBUTTON: 'ex_ibutton',
    HARSH_CORNERING: 'harsh_cornering',
    HARSH_BRAKING: 'harsh_braking',
    HARSH_ACCELERATION: 'harsh_acceleration',
    GEOFENCE: 'geofence',
    BATTERY_STATUS: 'battery_status',
    CRASH_DETECTION: 'ex_op_crash_detection',
    ACTIVE_DAY: 'active_day',
    ACTIVE_TIME: 'active_time',
    TOWING: 'towing',
    MDVR_CONNECTIVITY_STATUS: 'mdvr_connectivity'
}

const OPERATOR_LABEL = {
    YES: 'Yes',
    NO: 'No',
    MORE: 'More Than',
    MORE_EQUAL: 'More Than Equal',
    LESS: 'Less Than',
    LESS_EQUAL: 'Less Than Equal',
    INSIDE: 'Inside',
    OUTSIDE: 'Outside',
    INCLUDE: 'Include',
    EXCLUDE: 'Exclude',
    DETECTED: 'Detected',
    UNDETECTED: 'Undetected',
}

export const OPERATOR_VALUE = {
    [OPERATOR_LABEL.YES]: '==',
    [OPERATOR_LABEL.NO]: '!=',
    [OPERATOR_LABEL.MORE]: '>',
    [OPERATOR_LABEL.MORE_EQUAL]: '>=',
    [OPERATOR_LABEL.LESS]: '<',
    [OPERATOR_LABEL.LESS_EQUAL]: '<=',
    [OPERATOR_LABEL.INSIDE]: '>',
    [OPERATOR_LABEL.OUTSIDE]: '<',
    [OPERATOR_LABEL.INCLUDE]: '>',
    [OPERATOR_LABEL.EXCLUDE]: '<',
    [OPERATOR_LABEL.DETECTED]: '1',
    [OPERATOR_LABEL.UNDETECTED]: '0',
}

export const RULE_PARAM_OPERATOR = {
    [RULE_PARAMS.GNSS_STATUS]: [ OPERATOR_LABEL.YES, OPERATOR_LABEL.NO ],
    [RULE_PARAMS.IDLING_TIME]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.LESS ],
    [RULE_PARAMS.ACCELERATE]: [ OPERATOR_LABEL.MORE ],
    [RULE_PARAMS.PANIC_DI1_LATCH]: [ OPERATOR_LABEL.YES ],
    [RULE_PARAMS.iBUTTON]: [ OPERATOR_LABEL.DETECTED, OPERATOR_LABEL.UNDETECTED ],
    [RULE_PARAMS.CELL_CONNECTIVITY]: [ OPERATOR_LABEL.YES, OPERATOR_LABEL.NO ],
    [RULE_PARAMS.SPEED]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.LESS ],
    [RULE_PARAMS.SPEED]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.LESS ],
    [RULE_PARAMS.PARKING_TIME]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.LESS ],
    [RULE_PARAMS.IGNITION]: [ OPERATOR_LABEL.YES, OPERATOR_LABEL.NO ],
    [RULE_PARAMS.CRASH_DETECTION]: [ OPERATOR_LABEL.YES],
    [RULE_PARAMS.TOWING]: [ OPERATOR_LABEL.NO, OPERATOR_LABEL.YES],
    [RULE_PARAMS.HARSH_ACCELERATION]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.MORE_EQUAL ],
    [RULE_PARAMS.HARSH_BRAKING]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.MORE_EQUAL ],
    [RULE_PARAMS.HARSH_CORNERING]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.MORE_EQUAL ],
    [RULE_PARAMS.BATTERY_STATUS]: [ OPERATOR_LABEL.MORE, OPERATOR_LABEL.LESS ],
    [RULE_PARAMS.GEOFENCE]: [ OPERATOR_LABEL.INSIDE, OPERATOR_LABEL.OUTSIDE ],
    [RULE_PARAMS.ACTIVE_DAY]: [ OPERATOR_LABEL.INCLUDE, OPERATOR_LABEL.EXCLUDE ],
    [RULE_PARAMS.ACTIVE_TIME]: [ OPERATOR_LABEL.INCLUDE, OPERATOR_LABEL.EXCLUDE ],
    [RULE_PARAMS.MDVR_CONNECTIVITY_STATUS]: [ OPERATOR_LABEL.YES, OPERATOR_LABEL.NO, OPERATOR_LABEL.LESS_EQUAL, OPERATOR_LABEL.MORE_EQUAL ]
}